module.exports = __webpack_public_path__ + "static/media/img_3.dbcbcbc6.jpg";